module.exports = __webpack_public_path__ + "img/eth-selected.svg";